"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.initialFilterOptions = exports.initialOrderByOptions = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/distribution/list");
exports.initialOrderByOptions = {
    orderBy: 'name',
    order: 'asc'
};
exports.initialFilterOptions = {};
exports.initialState = {
    status: 'STANDBY',
    savingStatus: 'STANDBY',
    error: '',
    list: [],
    searchString: '',
    limit: 20,
    offset: 0,
    selected: [],
    deleteDialogToggled: false,
    orderByOptions: Object.assign({}, exports.initialOrderByOptions),
    filterOptions: Object.assign({}, exports.initialFilterOptions)
};
//#endregion
//#region LENS
const statusLens = monocle.Lens.fromProp('status');
const savingStatusLens = monocle.Lens.fromProp('savingStatus');
const listLens = monocle.Lens.fromProp('list');
const errorLens = monocle.Lens.fromProp('error');
const selectedLens = monocle.Lens.fromProp('selected');
const searchStringLens = monocle.Lens.fromProp('searchString');
const limitLens = monocle.Lens.fromProp('limit');
const offsetLens = monocle.Lens.fromProp('offset');
const orderByOptionsLens = monocle.Lens.fromProp('orderByOptions');
const filterOptionsLens = monocle.Lens.fromProp('filterOptions');
const deleteDialogToggledLens = monocle.Lens.fromProp('deleteDialogToggled');
const methods = {};
exports.methods = methods;
methods[Actions.FETCH_DISTRIBUTION_LIST_REQUEST] = (state, action) => fp.function.compose(statusLens.set('FETCHING'), selectedLens.set([]))(state);
methods[Actions.FETCH_DISTRIBUTION_LIST_SUCCESS] = (state, action) => fp.function.compose(statusLens.set('FETCHED'), listLens.set(action.payload.list))(state);
methods[Actions.FETCH_DISTRIBUTION_LIST_FAILED] = (state, action) => fp.function.compose(statusLens.set('FAILED'), errorLens.set(action.payload))(state);
methods[Actions.DELETE_DISTRIBUTIONS_REQUEST] = (state, action) => savingStatusLens.set('SAVING')(state);
methods[Actions.DELETE_DISTRIBUTIONS_SUCCESS] = (state, action) => savingStatusLens.set('SAVED')(state);
methods[Actions.DELETE_DISTRIBUTIONS_FAILURE] = (state, action) => fp.function.compose(savingStatusLens.set('FAILED'), errorLens.set(action.payload))(state);
methods[Actions.SET_SEARCH_STRING] = (state, action) => searchStringLens.set(action.payload.searchString)(state);
methods[Actions.DELETE_DISTRIBUTIONS_TOGGLE] = (state, action) => deleteDialogToggledLens.set(action.payload)(state);
methods[Actions.SET_LIMIT] = (state, action) => limitLens.set(action.payload.limit)(state);
methods[Actions.SET_OFFSET] = (state, action) => offsetLens.set(action.payload.offset)(state);
methods[Actions.SELECT_ITEMS] = (state, action) => selectedLens.modify((r) => action.payload.selected.reduce((acc, x) => {
    if (!acc.includes(x)) {
        acc.push(x);
    }
    return acc;
}, [...r]))(state);
methods[Actions.UNSELECT_ITEMS] = (state, action) => selectedLens.modify((r) => r.filter((i) => action.payload.unselected.indexOf(i) === -1))(state);
methods[Actions.SET_ORDER_BY_OPTIONS] = (state, action) => orderByOptionsLens.set(action.payload)(state);
methods[Actions.SET_FILTER_OPTIONS] = (state, action) => filterOptionsLens.modify((filters) => {
    const copy = Object.assign({}, filters);
    if (action.payload.value) {
        copy[action.payload.filter] = action.payload.value;
    }
    else {
        delete copy[action.payload.filter];
    }
    return copy;
})(state);
methods[Actions.CLEAR] = () => (Object.assign({}, exports.initialState));
//# sourceMappingURL=list.js.map